import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.NODE_ENV === 'development' ? '' : '/web/',
  routes: [{
    path: '/',
    name: 'home',
    meta: {
      title: '主页'
    },
    component: Home
  },
    {
      path: '/sy/competition',
      name: 'sy_competition',
      meta: {
        title: '海选'
      },
      component: () =>
        import ('@/views/sy/competition/competition.vue')
    },
    {
      path: '/sy/room',
      name: 'sy_room',
      meta: {
        title: 'Bee语音交友'
      },
      component: () =>
        import ('@/views/sy/room/room.vue')
    },
    {
      path: '/sy/room_hap',
      name: 'sy_room_hap',
      meta: {
        title: 'Bee语音交友'
      },
      component: () =>
        import ('@/views/sy/room/room_hap.vue')
    },
    {
      path: '/sy/pay',
      name: 'sy_pay',
      meta: {
        title: 'Bee语音视频充值'
      },
      component: () =>
        import ('@/views/sy/Pay.vue')
    },
    {
      path: '/sy/openId',
      name: 'sy_openid',
      meta: {
        title: 'Bee语音公众号获取openId'
      },
      component: () =>
        import ('@/views/sy/OpenId.vue')
    },
    {
      path: '/sy/payAli',
      name: 'sy_pay_ali',
      meta: {
        title: 'Bee语音视频充值'
      },
      component: () =>
        import ('@/views/sy/pay/PayAlipay.vue')
      // import ('@/views/sy/PayAlipay.vue')
    }, {
      path: '/sy/payAliSuccess',
      name: 'sy_pay_ali_success',
      meta: {
        title: '充值成功'
      },
      component: () =>
        import ('@/views/sy/pay/PayAlipaySuccess.vue')
      // import ('@/views/sy/PayAlipaySuccess.vue')
    },
    {
      path: '/sy/payH5',
      name: 'sy_payh5',
      meta: {
        title: '充值'
      },
      component: () =>
        import ('@/views/sy/PayH5.vue')
    },
    {
      path: '/sy/gh',
      name: 'sy_gh',
      meta: {
        title: '公会招募'
      },
      component: () =>
        import ('@/views/sy/GH.vue')
    },
    {
      path: '/sy/dzp',
      name: 'sy_dzp',
      meta: {
        title: '幸运大转盘'
      },
      component: () =>
        import ('@/views/sy/DZP.vue')
    },
    {
      path: '/sy/dzp/prize',
      name: 'sy_dzp_prize',
      meta: {
        title: '大转盘中奖记录'
      },
      component: () =>
        import ('@/views/sy/DZP_Prize.vue')
    },
    {
      path: '/sy/game/info',
      name: 'sy_game_info',
      component: () =>
        import ('@/views/sy/Game_Info.vue')
    },
    {
      path: '/sy/zjd',
      name: 'sy_zjd',
      meta: {
        title: '砸蛋小游戏'
      },
      component: () =>
        import ('@/views/sy/ZJD.vue')
    },
    {
      path: '/sy/zjd/info',
      name: 'sy_zjd_info',
      meta: {
        title: '砸金蛋-规则'
      },
      component: () =>
        import ('@/views/sy/ZJD_info.vue')
    },
    {
      path: '/sy/zjd/rank',
      name: 'sy_zjd_rank',
      meta: {
        title: '超级幸运星'
      },
      component: () =>
        import ('@/views/sy/ZJD_rank.vue')
    },
    {
      path: '/sy/zjdRank',
      name: 'zjdRank',
      meta: {
        title: '砸金蛋排行榜'
      },
      component: () =>
        import ('@/views/sy/zjdRank.vue')
    },
    {
      path: '/sy/zjd/rank2',
      name: 'sy_zjd_rank2',
      meta: {
        title: '超级幸运星历史记录'
      },
      component: () =>
        import ('@/views/sy/ZJD_rank2.vue')
    },
    {
      path: '/sy/rank',
      name: 'sy_rank',
      meta: {
        title: '七夕打榜'
      },
      component: () =>
        import ('@/views/sy/Rank.vue')
    },
    {
      path: '/sy/cprank_20210214',
      name: 'sy_cprank_20210214',
      meta: {
        title: '2021情人节CP榜'
      },
      component: () =>
        import ('@/views/sy/CP_rank_20210214.vue')
    },
    {
      path: '/sy/rank/info',
      name: 'sy_rank_info',
      meta: {
        title: '七夕打榜说明'
      },
      component: () =>
        import ('@/views/sy/RankInfo.vue')
    },
    {
      path: '/sy/rank/res',
      name: 'sy_rank_res',
      meta: {
        title: '七夕打榜结果'
      },
      component: () =>
        import ('@/views/sy/RankRes.vue')
    },
    {
      path: '/sy/get_coin',
      name: 'sy_get_coin',
      meta: {
        title: '领取蜜豆'
      },
      component: () =>
        import ('@/views/sy/QixiGetCoin.vue')
    },
    {
      path: '/sy/giving',
      name: 'sy_giving',
      meta: {
        title: '首冲礼包'
      },
      component: () =>
        import ('@/views/sy/Giving.vue')
    },
    {
      path: '/sy/rank/week',
      name: 'sy_rank_week',
      meta: {
        title: '周星争霸'
      },
      component: () =>
        import ('@/views/sy/WeekRank.vue')
    },
    {
      path: '/sy/jw',
      name: 'sy_jw',
      meta: {
        title: '乐聊本月违规公示'
      },
      component: () =>
        import ('@/views/sy/Jw.vue')
    },
    {
      path: '/sy/config_guide',
      name: 'sy_config_guide',
      meta: {
        title: '封面图配置指南'
      },
      component: () =>
        import ('@/views/sy/Config_guide.vue')
    },
    {
      path: '/sy/zatgz',
      name: 'sy_zatgz',
      meta: {
        title: '真爱团规则说明'
      },
      component: () =>
        import ('@/views/sy/Zatgz.vue')
    },
    {
      path: '/sy/download',
      name: 'sy_download',
      meta: {
        title: 'Bee语音 派对聊天|走心交友|游戏陪玩'
      },
      component: () =>
        import ('@/views/sy/Download.vue')
    },
    {
      path: '/sy/new/download',
      name: 'sy_new_download',
      meta: {
        title: 'Bee语音 恋爱交友|游戏陪玩|连麦哄睡'
      },
      component: () =>
        import ('@/views/sy/Download.vue')
    },
    {
      path: '/sy/letv/download',
      name: 'sy_letv_download',
      meta: {
        title: 'Bee语音 恋爱交友|游戏陪玩|连麦哄睡'
      },
      component: () =>
        import ('@/views/sy/Download.vue')
    },
    {
      path: '/sy/unlink',
      name: 'sy_unlink',
      meta: {
        title: 'Bee语音 恋爱交友|游戏陪玩|连麦哄睡'
      },
      component: () =>
        import ('@/views/sy/Download.vue')
    },
    {
      path: '/sy/letv/unlink',
      name: 'sy_letv_unlink',
      meta: {
        title: 'Bee语音 恋爱交友|游戏陪玩|连麦哄睡'
      },
      component: () =>
        import ('@/views/sy/Download.vue')
    },
    {
      path: '/sy/bf/unlink',
      name: 'sy_bf_unlink',
      meta: {
        title: 'Bee语音 恋爱交友|游戏陪玩|连麦哄睡'
      },
      component: () =>
        import ('@/views/sy/Download.vue')
    },
    {
      path: '/sy/link_test',
      name: 'sy_link_test',
      meta: {
        title: 'deeplink测试'
      },
      component: () =>
        import ('@/views/sy/Link.vue')
    },
    {
      path: '/sy/share',
      name: 'sy_share',
      meta: {
        title: 'Bee语音分享'
      },
      component: () =>
        import ('@/views/sy/Shares.vue')
    },
    {
      path: '/sy/redPacketShare',
      name: 'sy_redPacketShare',
      meta: {
        title: 'Bee语音红包分享'
      },
      component: () =>
        import ('@/views/sy/redPacketShare.vue')
    },
    {
      path: '/sy/downloadPage',
      name: 'sy_downloadPage',
      meta: {
        title: 'Bee语音'
      },
      component: () =>
        import ('@/views/sy/downloadPage.vue')
    },
    {
      path: '/sy/staticActivity',
      name: 'sy_staticActivity',
      meta: {
        title: '活动说明'
      },
      component: () =>
        import ('@/views/sy/Static_activity.vue')
    },
    {
      path: '/sy/luckGift',
      name: 'sy_luckGift',
      meta: {
        title: '礼物猜猜看'
      },
      component: () =>
        import ('@/views/sy/LuckGift.vue')
    },
    {
      path: '/sy/dailyList',
      name: 'sy_dailyList',
      meta: {
        title: '每日榜单'
      },
      component: () =>
        import ('@/views/sy/dailyList.vue')
    },
    {
      path: '/sy/carnival',
      name: 'sy_carnival',
      meta: {
        title: '嘉年华榜单'
      },
      component: () =>
        import ('@/views/sy/carnival.vue')
    },
    {
      path: '/sy/anniversaryRank',
      name: 'sy_anniversaryRank',
      meta: {
        title: '周年庆榜单'
      },
      component: () =>
        import ('@/views/sy/AnniversaryRank.vue')
    },
    {
      path: '/sy/anniversaryLuckStar',
      name: 'sy_anniversaryLuckStar',
      meta: {
        title: '周年庆幸运星'
      },
      component: () =>
        import ('@/views/sy/AnniversaryLuckStar.vue')
    },
    {
      path: '/sy/pay/pay',
      name: 'sy_newpay',
      meta: {
        title: 'Bee语音视频充值'
      },
      component: () =>
        import ('@/views/sy/pay/Pay.vue')
    },
    {
      path: '/sy/pay/payAli',
      name: 'sy_newpay_ali',
      meta: {
        title: 'Bee语音视频充值'
      },
      component: () =>
        import ('@/views/sy/pay/PayAlipay.vue')
    }, {
      path: '/sy/pay/payAliSuccess',
      name: 'sy_newpay_ali_success',
      meta: {
        title: '充值成功'
      },
      component: () =>
        import ('@/views/sy/pay/PayAlipaySuccess.vue')
    },
    {
      path: '/sy/pay/payH5',
      name: 'sy_newpayh5',
      meta: {
        title: '充值'
      },
      component: () =>
        import ('@/views/sy/pay/PayH5.vue')
    },
    {
      path: '/sy/MidAutumnRank2020',
      name: 'sy_midAutumnRank2020',
      meta: {
        title: '2020中秋节榜单'
      },
      component: () =>
        import ('@/views/sy/MidAutumnRank2020.vue')
    },
    {
      path: '/sy/newyear',
      name: 'sy_newyear',
      meta: {
        title: '2021拜大年'
      },
      component: () =>
        import ('@/views/sy/newyear.vue')
    },
    {
      path: '/doc/:app/:type',
      name: 'sy_doc',
      meta: {
        title: ''
      },
      component: () =>
        import ('@/views/sy/Doc.vue')
    },
    {
      path: '/sy/sdk',
      name: 'sy_sdk',
      meta: {
        title: ''
      },
      component: () =>
        import ('@/views/sy/SDK.vue')
    },
    {
      path: '/sy/rank520',
      name: 'sy_rank520',
      meta: {
        title: '520打榜'
      },
      component: () =>
        import ('@/views/sy/Rank520.vue')
    },
    {
      path: '/sy/cprank_2021qixi',
      name: 'sy_cprank_2021qixi',
      meta: {
        title: '2021七夕CP榜'
      },
      component: () =>
        import ('@/views/sy/CP_rank_2021qixi.vue')
    },
    {
      path: '/sy/link_test2',
      name: 'sy_link_test2',
      meta: {
        title: 'deeplink测试'
      },
      component: () =>
        import ('@/views/sy/Link2.vue')
    },
    {
      path: '/sy/le_deeplink',
      name: 'sy_le_deeplink',
      meta: {
        title: '乐视视频调起sdk'
      },
      component: () =>
        import ('@/views/sy/le_deeplink.vue')
    },
    {
      path: '/sy/roombestid',
      name: 'sy_roombestid',
      meta: {
        title: '房间靓号活动'
      },
      component: () =>
        import ('@/views/sy/RoomBestid.vue')
    },
    {
      path: '/sy/cprank_20210909',
      name: 'cprank_20210909',
      meta: {
        title: '2021.9.9告白日活动'
      },
      component: () =>
        import ('@/views/sy/CP_rank_20210909.vue')
    },
    {
      path: '/sy/MidAutumnRank2021',
      name: 'sy_midAutumnRank2021',
      meta: {
        title: '2021中秋节榜单'
      },
      component: () =>
        import ('@/views/sy/MidAutumnRank2021.vue')
    },
    {
      path: '/sy/reward/receive/:eventID',
      name: 'sy_reward_receive',
      meta: {
        title: ''
      },
      component: () =>
        import ('@/views/sy/RewardReceive.vue')
    },
    {
      path: '/le/push',
      name: 'le_push',
      meta: {
        title: 'push审核'
      },
      component: () =>
        import ('@/views/le/Push.vue')
    },
    {
      path: '/le/img_handle',
      name: 'le_img_handle',
      meta: {
        title: '图片处理'
      },
      component: () =>
        import ('@/views/le/Img_Handle.vue')
    },
    {
      path: '/le/source',
      name: 'le_source',
      meta: {
        title: 'source数据'
      },
      component: () =>
        import ('@/views/le/Source.vue')
    },
    {
      path: '/le/sourcev2',
      name: 'le_source',
      meta: {
        title: 'source数据'
      },
      component: () =>
        import ('@/views/le/SourceV2.vue')
    },
    {
      path: '/le/play',
      name: 'le_play',
      meta: {
        title: '乐视视频M站'
      },
      component: () =>
        import ('@/views/le/Play.vue')
    },
    {
      path: '/le/audit/play',
      name: 'le_audit_play',
      meta: {
        title: '乐视视频审核播放'
      },
      component: () =>
        import ('@/views/le/AuditPlay.vue')
    },
    {
      path: '/le/audit/dashboard',
      name: 'le_audit_dashboard',
      meta: {
        title: '乐视视频审核后台'
      },
      component: () =>
        import ('@/views/le/AuditDashboard.vue')
    },
    {
      name: '404',
      path: '/404',
      component: () =>
        import ('@/views/404.vue')
    },
    {
      path: '*', // 此处需特别注意至于最底部
      redirect: '/404'
    }
  ]
})
